﻿//step 1: find select
var select = document.getElementById("publicationsFilter");

function filterPublications() {
    // Step 3: find selected option
    var option = select.options[select.selectedIndex].value;
    // Step 4: Remove spaces from option value, and replace with '%20'
    // var trimURL = option.split(" ").join("%20");
    // Step 5: Set base url 
    // var urlStart = "https://main-lhc.appius.co.uk/news-hub-page/publications/?type=";
    // Step 6: take base url and append trimmed to it
    // var urlParam = urlStart + trimURL;

    var urlParams = new URLSearchParams(window.location.search)
    urlParams.set("type", option)
    window.location.search = urlParams.toString();
}

//Step 2: add change event to select and invoke function

if (select) {
    select.addEventListener("change", filterPublications);
}

